import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Class-name combinator (port of the reference's lib/utils.ts `cn`).
 * clsx handles conditionals, twMerge resolves Tailwind conflicts so a
 * caller's `px-3` beats a component default `px-5` instead of colliding.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
